import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./i18n";
import "./App.css";

import Home from "./pages/Home";
import CreateGroup from "./pages/CreateGroup";
import GroupDashboard from "./pages/GroupDashboard";
import DrawResults from "./pages/DrawResults";
import GroupsList from "./pages/GroupsList";
import AuthVerify from "./pages/AuthVerify";
import JoinGroup from "./pages/JoinGroup";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Footer from "./components/Footer";

import useAuthStore from "./store/authStore";
import useThemeStore from "./store/themeStore";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? children : <Navigate to="/" replace />;
};
function App() {
  const { theme } = useThemeStore();
  const initializeAuth = useAuthStore((state) => state.initializeAuth);

  useEffect(() => {
    initializeAuth();
    // Apply theme to document
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme, initializeAuth]);

  return (
    <div className="App">
      <BrowserRouter>
        <div className="flex min-h-screen flex-col">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/auth/verify" element={<AuthVerify />} />
            <Route path="/join/:inviteCode" element={<JoinGroup />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />

            <Route
              path="/create-group"
              element={
                <ProtectedRoute>
                  <CreateGroup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/groups"
              element={
                <ProtectedRoute>
                  <GroupsList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/group/:groupId"
              element={
                <ProtectedRoute>
                  <GroupDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/group/:groupId/draw"
              element={
                <ProtectedRoute>
                  <DrawResults />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
